// Library
import React from 'react';

// CSS Style for this module
import styles from './separator.module.scss';

interface SeparatorProps {
	/**
	 * Custom styles of the separator
	 */
	customStyles?: string;
}

/**
 * Separator generic component
 * @returns an separator line with vertical margins
 */
export const Separator = ({ customStyles }: SeparatorProps) => (
	<div className={[styles.separator, customStyles].join(' ')} />
);
